import React from 'react'

import {
  Typography,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Grid,
  makeStyles,
  Link,
  Button,
} from '@material-ui/core'

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined'
import { useWindowSize } from '@yapay/react-components/hooks'

import useFetch from 'hooks/useFetch'
import * as service from 'service'
import CardPlan from 'views/Subscribe/components/CardPlan'
import helpers from 'helpers/contractPlans'
import styles from '../Subscribe/SubscribeMain/styles'
import { routes } from 'routes'
import { reverse } from 'named-urls'

import ContractPlanMigrateContext from 'contexts/ContractPlanMigrateContext'
import { useParams, useHistory } from 'react-router-dom'

const useStyles = makeStyles(styles)

const MigratePlanShow = () => {
  const classes = useStyles()
  const params = useParams()
  const context = React.useContext(ContractPlanMigrateContext)
  const history = useHistory()
  const windowSize = useWindowSize()
  const [plans, setPlans] = React.useState([])
  const [page, setPage] = React.useState(1)
  const [searchText, setSearchText] = React.useState('')
  const contractPlanId = params.contractPlanId
  const sizePage = 6

  const { response: contractPlan } = useFetch(
    service.recurrence.contractPlans.get,
    {
      contractPlanId,
    },
  )

  const selectPlans = plan => {
    const contractPlanForId = contractPlan?.data.contractPlan

    context.setData(data => ({
      ...data,
      oldPlan: {
        name: contractPlanForId.plan.name,
        description: contractPlanForId.plan.description,
        periodicity: contractPlanForId.periodicity,
        price: contractPlanForId.price,
        quantity: contractPlanForId.quantity,
      },
    }))

    context.setData(data => ({
      ...data,
      newPlan: {
        name: plan.name,
        code: plan.code,
        description: plan.description,
        periodicity: plan.periodicity,
        price: plan.price,
        quantity: plan.quantity,
      },
    }))

    history.push(
      reverse(routes.contracts.migratePlan.steps.edit, {
        contractId: params.contractId,
        contractPlanId: params.contractPlanId,
      }),
    )
  }

  const handleChange = event => {
    setSearchText(event.target.value)
    setPage(1)
  }

  const nextPage = () => {
    setPage(page + 1)
  }

  const filteredPlans = React.useMemo(() => {
    if (!searchText) {
      return plans
    }
    return plans.filter(plan =>
      plan.name.toUpperCase().includes(searchText.toUpperCase()),
    )
  }, [plans, searchText])

  const showMore = React.useMemo(() => {
    return sizePage * page < filteredPlans.length
  }, [page, filteredPlans])

  const paginatedPlans = React.useMemo(() => {
    return filteredPlans.slice(0, sizePage * page)
  }, [filteredPlans, sizePage, page])

  const listPlans = async () => {
    const response = await service.recurrence.contractPlans.get({
      contractPlanId,
    })
    const contractPlan = response.data.contractPlan
    const responsePlan = await service.recurrence.plans.get({
      page: 1,
      perPage: 9999,
    })
    const fullPlans = responsePlan.data.plans
    setPlans(helpers.extractPlansMigrate(fullPlans, contractPlan))
  }

  React.useEffect(() => {
    listPlans()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box p={{ xs: 2, sm: 4 }}>
      {windowSize.isDesktop ? (
        <Grid container alignItems="center">
          <Grid item md={8}>
            <Typography variant="h4" color="textSecondary">
              Para qual plano deseja migrar?
            </Typography>
          </Grid>
          <Grid item md={4}>
            <TextField
              label="Busque pelo nome do plano"
              variant="outlined"
              fullWidth
              onChange={handleChange}
              InputProps={{
                type: 'search',
                endAdornment: (
                  <InputAdornment>
                    <IconButton>
                      <SearchOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      ) : (
        <>
          <Typography variant="h4" color="textSecondary">
            Para qual plano deseja migrar?
          </Typography>
          <Box
            py={2}
            position="sticky"
            top={56}
            zIndex={1}
            style={{ backgroundColor: 'white' }}
          >
            <TextField
              label="Busque pelo nome do plano"
              variant="outlined"
              fullWidth
              onChange={handleChange}
              InputProps={{
                type: 'search',
                endAdornment: (
                  <InputAdornment>
                    <IconButton>
                      <SearchOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </>
      )}
      <Box
        mt={2}
        display="flex"
        alignItems="stretch"
        justifyContent="center"
        flexWrap="wrap"
      >
        {paginatedPlans?.map(plan => (
          <CardPlan
            plan={plan}
            key={plan.id}
            className={classes.plan}
            expandOnMouseOver
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              disableElevation
              fullWidth
              onClick={() => selectPlans(plan)}
            >
              MIGRAR
            </Button>
          </CardPlan>
        ))}
      </Box>
      {showMore && (
        <Box display="flex" justifyContent="center" mt={6}>
          <Link component="button" onClick={nextPage}>
            <Typography variant="body2" color="secondary">
              VER MAIS PLANOS
            </Typography>
          </Link>
        </Box>
      )}
    </Box>
  )
}

export default MigratePlanShow
